
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dataService } from "../../../services/data.services";


const initialState = {
    loading: true,
    error: '',
    success: '',
}
export const BranchUser = createAsyncThunk('branch-list', async (searchParams) => {
    let res = await dataService.GetAPI(searchParams);
    return res
})
const BranchUserSlice = createSlice({

    name: 'branch-list',
    initialState,
    reducers: {

    },
    extraReducers: {
        [BranchUser.pending]: (state) => {
            state.loading = true
            state.error = null
        },
        [BranchUser.fulfilled]: (state, action) => {
            state.loading = false;
            if(!action?.payload?.error && action?.payload?.data.status===200){
                state.List=action?.payload?.data.data;
                
            }else{
                state.error=action?.payload?.data?.message
            }
        },
        [BranchUser.rejected]: (state, { payload }) => {
            state.loading = false
            state.error = payload?.message?.message
        },
    },
})
export const {  } = BranchUserSlice.actions;
export default BranchUserSlice.reducer